const colorMap = {
    A: "bg-danger",
    B: "bg-primary",
    C: "bg-success",
    D: "bg-warning",
    E: "bg-info",
    F: "bg-secondary",
    G: "bg-dark",
    H: "bg-danger",
    I: "bg-primary",
    J: "bg-success",
    K: "bg-warning",
    L: "bg-info",
    M: "bg-secondary",
    N: "bg-dark",
    O: "bg-danger",
    P: "bg-primary",
    Q: "bg-success",
    R: "bg-warning",
    S: "bg-info",
    T: "bg-secondary",
    U: "bg-dark",
    V: "bg-danger",
    W: "bg-primary",
    X: "bg-success",
    Y: "bg-warning",
    Z: "bg-info",
    default: "bg-light text-dark"
  };
  
  const UserAvatar = ({ name, size = 40 }) => {
    const initial = name?.charAt(0).toUpperCase() || '?';
    const bgClass = colorMap[initial] || colorMap.default;
  
    const style = {
      width: size,
      height: size,
      fontSize: size / 2,
      lineHeight: `${size}px`,
      textAlign: 'center',
    };
  
    return (
      <div
        className={`rounded-circle ${bgClass} text-white fw-bold d-inline-block`}
        style={style}
      >
        {initial}
      </div>
    );
  };
  
  export default UserAvatar;
  